import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from "../image/bookly_logo.png";
import './LoginPortal.css'; // Share styling

const RegisterPortal = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 portal-background">
      <div className="portal-logo-wrapper mb-4">
        <img src={logo} alt="Bookly Logo" className="portal-logo-img" />
        <h1 className="portal-brand-title">Bookly</h1>
      </div>

      <div className="portal-card-container shadow rounded p-5 text-center">
        <h3 className="mb-2 text-dark font-weight-bold">Inscription</h3>
        <p className="text-muted mb-4">Choisissez le type de compte à créer</p>

        <div className="portal-buttons-grid">
          {/* Client Registration */}
          <button 
            className="portal-choice-card client-card"
            onClick={() => navigate('/ClientRegister')}
          >
            <div className="portal-card-icon">👤</div>
            <h4 className="portal-card-title">Compte Client</h4>
            <p className="portal-card-desc">
              Créez votre compte pour réserver vos rendez-vous et suivre vos favoris.
            </p>
            <div className="portal-card-arrow">S'inscrire ➔</div>
          </button>

          {/* Provider Registration */}
          <button 
            className="portal-choice-card provider-card"
            onClick={() => navigate('/ProviderRegister')}
          >
            <div className="portal-card-icon">💼</div>
            <h4 className="portal-card-title">Compte Prestataire</h4>
            <p className="portal-card-desc">
              Enregistrez votre établissement et commencez à recevoir des réservations.
            </p>
            <div className="portal-card-arrow">S'inscrire ➔</div>
          </button>
        </div>

        <div className="text-center mt-4">
          <span className="text-muted small">
            Déjà un compte ? Se connecter en tant que{" "}
            <span 
              className="text-primary font-weight-bold cursor-pointer" 
              onClick={() => navigate('/Login')}
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
            >
              Client
            </span>{" "}
            ou{" "}
            <span 
              className="text-success font-weight-bold cursor-pointer" 
              onClick={() => navigate('/ProviderLogin')}
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
            >
              Prestataire
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default RegisterPortal;
